import { render, staticRenderFns } from "./ReminderRow.vue?vue&type=template&id=5e937bd5&"
import script from "./ReminderRow.vue?vue&type=script&lang=js&"
export * from "./ReminderRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports